import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { Switch, Button } from 'antd';

import { DataContext } from '../../../init/getData';

import Select from 'react-select';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

const TabsPermission = (props) => {

  const { api, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const usersettings = userData.role.name;

  const { showModal, toggleModal, refreshTable, tittle, idRow } = props;



  const [loadingEffect, setLoadingEffect] = useState(false);

  const [settings, setSettings] = useState({});


  useEffect(() => {

    if (idRow) {
      setSettings(
        {
          dashboardTab: idRow.dashboardTab,
          dailyEntryTab: idRow.dailyEntryTab,
          accountTab: idRow.accountTab,
          cashTab: idRow.cashTab,
          hrTab: idRow.hrTab,
          purchaseTab: idRow.purchaseTab,
          salesTab: idRow.salesTab,
          expenseTab: idRow.expenseTab,
          stockTab: idRow.stockTab,
          inventoryTab: idRow.inventoryTab,
          reportTab: idRow.reportTab,
          toolTab: idRow.toolTab,
          settingTab: idRow.settingTab,
          retailTab: idRow.retailTab,
        }
      )

    }
  }, [idRow]);

  const handleSubmit = async () => {
    setLoadingEffect(true);

    const id = idRow.id;

    let res = await api.post(`/role/editPermissions`, JSON.stringify({ id, settings }))
    if (res.data.status) {
      toast.success(res.data.message);
      refreshTable();
      toggleModal();
    }
    else {
      toast.error(res.data.message);
    }

    setLoadingEffect(false);
  }

  const handleChange = (name, value) => {
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  }



  return (
    <Modal show={showModal} backdrop="static" size='md' onHide={toggleModal} >
      <Modal.Header style={{ background: "#23576a" }} className="modal-close-button" closeButton>
        <Modal.Title style={{ color: "white" }}>Tabs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form style={{ marginBottom: '10%', marginTop: '5%', alignItems: 'center' }}>

          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Dashboard Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('dashboardTab', e)} checked={settings?.dashboardTab} />
            </Col>
          </Row>




          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Daily Entry</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('dailyEntryTab', e)} checked={settings?.dailyEntryTab} />
            </Col>
          </Row>



          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Accounts Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('accountTab', e)} checked={settings?.accountTab} />
            </Col>
          </Row>
          
          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Cash Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('cashTab', e)} checked={settings?.cashTab} />
            </Col>
          </Row>
          
          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>HR Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('hrTab', e)} checked={settings?.hrTab} />
            </Col>
          </Row>


          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Purchase Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('purchaseTab', e)} checked={settings?.purchaseTab} />
            </Col>
          </Row>

          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Sales Tab </Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('salesTab', e)} checked={settings?.salesTab} />
            </Col>
          </Row>
          
          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Expense Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('expenseTab', e)} checked={settings?.expenseTab} />
            </Col>
          </Row>

          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Stock Tab </Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('stockTab', e)} checked={settings?.stockTab} />
            </Col>
          </Row>




          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Inventory Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('inventoryTab', e)} checked={settings?.inventoryTab} />
            </Col>
          </Row>

          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Report Tab </Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('reportTab', e)} checked={settings?.reportTab} />
            </Col>
          </Row>

          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Tool Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('toolTab', e)} checked={settings?.toolTab} />
            </Col>
          </Row>


          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Setting Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('settingTab', e)} checked={settings?.settingTab} />
            </Col>
          </Row>

          <Row>
            <Col md={1}>
            </Col>
            <Col>
              <Form.Label column md={5}>Retail Tab</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('retailTab', e)} checked={settings?.retailTab} />
            </Col>
          </Row>


        </Form>


        <div className="modal-footer">

          <Button type="primary" loading={loadingEffect} onClick={handleSubmit}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>


          {loadingEffect && (
            <span className="spinner-border spinner-border-md" settings="status" aria-hidden="true"></span>
          )}

        </div>


      </Modal.Body>
    </Modal>
  )
}


export default TabsPermission;